import { createContext, RefObject, useContext } from "react";

type RadixBaseUiInteropContext = {
    radixRef: RefObject<HTMLElement | null>;
};

export const RadixBaseUiInteropContext = createContext<RadixBaseUiInteropContext | null>(null);

export function useRadixBaseUiInterop() {
    const ctx = useContext(RadixBaseUiInteropContext);
    return ctx?.radixRef;
}
